module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Profila informācija/paroles maiņa")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('table', {
    staticClass: "ui very basic table"
  }, [_c('tbody', [_c('tr', [_c('td', [(_vm.user.person_type == 1) ? _c('span', [_vm._v("Vārds Uzvārds")]) : _c('span', [_vm._v("Nosaukums")]), _vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.name_surname))])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.user.person_type == 1) ? _c('span', [_vm._v("Personas kods")]) : _c('span', [_vm._v("Reģistrācijas nr.")]), _vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.legalid))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("E-pasts:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tālrunis:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), (_vm.user.lyones_id != '') ? _c('tr', [_c('td', [_vm._v("Lyoness id:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.lyones_id))])]) : _vm._e(), _vm._v(" "), (_vm.user.bail_payed > 0 || _vm.user.bail_required > 0) ? _c('tr', [_c('td', [_vm._v("Iemaksātā drošības nauda:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.bail_payed) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.user.bail_payed > 0 || _vm.user.bail_required > 0) ? _c('tr', [_c('td', [_vm._v("Vajadzīgā drošības nauda:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.bail_required) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.user.pay_later > 0 && _vm.user.credit_limit > 0) ? _c('tr', [_c('td', [_vm._v("Kredītlimits:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.credit_limit) + " €")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    attrs: {
      "id": "newsletter",
      "type": "checkbox",
      "number": ""
    },
    domProps: {
      "checked": _vm.user.newsletter
    },
    on: {
      "change": _vm.updateNewsletter
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newsletter"
    }
  }, [_vm._v("Vēlos saņemt jaunumus")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [(_vm.passwordChanged) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('p', [_vm._v("Parole veiksmīgi nomainīta!")])]) : _vm._e(), _vm._v(" "), (_vm.storeStatus.error != '') ? _c('div', {
    staticClass: "ui negative message"
  }, [_vm._v("\n      Parolei jāsatur vismas 8 simbolus!\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('h4', {
    staticClass: "ui dividing header"
  }, [_vm._v("Paroles maiņa")]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Jaunā parole")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Minimums 8 simboli"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Jaunā parole atkārtoti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.paswordRepeat),
      expression: "credentials.paswordRepeat"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Minimums 8 simboli"
    },
    domProps: {
      "value": (_vm.credentials.paswordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "paswordRepeat", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "ui right floated custom_brown button",
    class: {
      loading: _vm.showLoader
    },
    attrs: {
      "disabled": _vm.credentials.password == '' || _vm.credentials.password.legend < 8 || _vm.credentials.password != _vm.credentials.paswordRepeat
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("\n    Mainīt paroli")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-073d9f0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfilePage.vue
// module id = 316
// module chunks = 1